import angular from 'angular';
import {
  loaderService,
  reportsDataService,
  orgDataService,
  ssDialogService
} from 'app/services';
import {
  alerts,
  confirmDialog,
  actionIcon
} from 'app/components/global';
import editReportScheduleDialog from '../../dialog.editReportScheduleDialog';
import directive from './report-schedule.directive';
import controller from './report-schedule.controller';


export default angular.module('app.components.reports.scheduledReports.reportSchedule', [
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  orgDataService,
  loaderService,
  actionIcon,
  editReportScheduleDialog,
])
  .directive('srReportSchedule', directive)
  .controller('SRReportScheduleController', controller)
  .name;

console.log('app.components.reports.scheduledReports.reportSchedule created');
